import React, { useEffect, useState } from "react";
import Header from "../component/menu/Header";
import { constants } from "../constant/constants";
import PaymentCardComponent from "../component/PaymentCardComponent";
import SideMenu from "../component/menu/SideMenu";
import { Flex, Image, notification, Progress, Spin } from "antd";
import SummaryComponent from "../component/SummaryComponent";
import OrderComponent from "../component/OrderComponent";
import TrendingItemsChart from "../component/charts/TrendingItemsChart";
import { getCurrentDate, roundNumber, showCookingTimeField } from "../utils/Common";
import OrderPaymentModal from "../component/modals/OrderPaymentModal";
import ConfirmationModal from "../component/modals/ConfirmationModal";
import useUserStore from "../stores/store";
import ApiService from "../utils/ApiService";
import ViewOrderLogModal from "../component/modals/ViewOrderLogModal";
import { getFormatedOrderList } from "../services/order-details-service";
import CustomLoader from "../component/menu/CustomLoader";
import { useNavigate } from "react-router-dom";
import DisplayInvoice from "../component/modals/DisplayInvoiceModal";
import DataNotFound from "../component/common/DataNotFound";
import { getRestaurantIdWithAuthToken } from "../utils/authUtils";
import useOrderStore from "../stores/useOrderStore";
import { getOrderDefaultFilter } from "../utils/store.helper";
import OrderPaymentRefundModal from "../component/modals/OrderPaymentRefundModal";
import DashboardReportPrint from "../component/restaurants/reports/DashboardReportPrint";

function Home() {
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isViewLogModalOpen, setIsViewLogModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isPaymentRefundModalOpen, setIsPaymentRefundModalOpen] = useState(false);
  const [isDisplayInvoice, setIsDisplayInvoice] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [selectedItem, setSelectedItem] = useState({});
  const [amountToPay, setAmountToPay] = useState("");
  const [cookingTime, setCookingTime] = useState("30");
  const [showCookingTime, setShowCookingTime] = useState(false);
  const [titleMessage, setTitleMessage] = useState("");
  const [summaryData, setSummaryData] = useState({});
  // const [newOrderId, setNewOrderId] = useState("");
  const [action, setAction] = useState("");
  const [totalCash, setTotalCash] = useState("");
  const [totalCard, setTotalCard] = useState("");
  const [totalOnline, setTotalOnline] = useState("");
  const [totalMfsAmount, setTotalMfsAmount] = useState("");
  const [trendingItemsData, setTrendingItemsData] = useState([]);
  const [shouldLockRow, setShouldLockRow] = useState("");
  const { user, isLoggedIn, restaurantId, clearUser, showNotification, tableManagement } = useUserStore();
  const {
    newOrderId,
    shouldFetchDashboardOrders,
    setShouldFetchDashboardOrders,
    setDashboardOrders,
    dashboardOrders,
    setNewOrderId,
  } = useOrderStore();

  // Initialize dynamic payments array
  const [payments, setPayments] = useState([]);
  const [loadingOrder, setLoadingOrder] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);

  const twoColors = {
    "0%": "#572D86",
    "100%": "#572D86",
  };
  const onClickAddButton = () => {
    navigate(tableManagement === "Active" ? "/table" : "/order/add");
  };

  const onClickSeeAllButton = () => {
    navigate("/order");
  };

  const onHandleOrderAction = (val, action) => {
    setShowCookingTime(showCookingTimeField(val));
    setTitleMessage(`<span class="text-purple">Order ID</span> - ${val.order_id}`);
    switch (action) {
      case constants.ORDER.ACCEPT: {
        if (val.paid === 0) {
          // If unpaid, open the payment modal
          setAction(constants.ORDER.WAITING);
          setAmountToPay(val.total);
          setSelectedItem(val);
          setIsPaymentModalOpen(true);
          setShowCookingTime(showCookingTimeField({ status: "waiting" }));
        } else if (val.paid === 1) {
          // If paid, proceed with marking the order as "Waiting"
          setConfirmationMessage(`Are you sure you want to mark the order as processing for <b>0${val.name}</b> user?`);
          setSelectedItem(val);
          setAction(constants.ORDER.WAITING);
          setIsPaymentModalOpen(true);
          // setIsConfirmModalOpen(true);
          setShowCookingTime(showCookingTimeField({ status: "waiting" }));
        }
        break;
      }
      case constants.ORDER.PAID: {
        setAmountToPay(val.total);
        setSelectedItem(val);
        setIsPaymentModalOpen(true);
        break;
      }
      case constants.ORDER.REFUND: {
        setSelectedItem(val);
        setIsPaymentRefundModalOpen(true);
        break;
      }
      case constants.ORDER.INVOICE: {
        setSelectedItem(val);
        setIsDisplayInvoice(true);
        break;
      }
    }
  };
  const onConfirm = (record, action) => {
    setIsConfirmModalOpen(false);

    if (action === constants.ORDER.PAID) {
      return setIsPaymentModalOpen(true);
    }

    orderStatusChange(record, action);
  };

  const orderStatusChange = async (record) => {
    const status = action !== constants.ORDER.DECLINE ? 1 : 0;
    setShouldLockRow(record._id);
    let declined = await ApiService.ORDER_STATUS_CHANGE(
      {
        orderId: record._id,
        selection: status,
        cookingTime: record.cookingTime || "",
      },
      user.token.token
    );

    if (declined.code !== 200) {
      setShouldLockRow("");
      showNotification(declined?.data?.message || "Something went wrong. Please try again later.");
      return;
    }
    setIsPaymentModalOpen(false);
    setShouldLockRow("");
  };

  const onNotConfirm = () => {
    setIsPaymentModalOpen(false);
    setIsConfirmModalOpen(false);
  };
  /*API START*/
  const getDashboardSummary = (currentDate) => {
    if (isLoggedIn) {
      let params = {
        restaurantId,
        currentDate: getCurrentDate(),
      };
      ApiService.DASHBOARD_SUMMARY(params, user?.token?.token).then((res) => {
        if (res.status === 401) {
          clearUser();
          navigate("/");
        }

        if (res.code === 200) {
          setSummaryData(res.payload);
        }
      });
      ApiService.GET_TRENDING_FOODS(params, user?.token?.token).then((res) => {
        if (res.code === 200) {
          let trendingData = res?.payload?.records.map((item) => {
            return {
              name: item.name,
              sales: item.saleCount,
            };
          });
          setTrendingItemsData(trendingData);
        }
      });
    }
  };

  const fetchPaymentSummary = () => {
    if (isLoggedIn) {
      const params = {
        restaurantId,
        date: getCurrentDate(),
      }; // Add dynamic date if needed
      ApiService.PAYMENT_SUMMARY(params, user?.token?.token).then((res) => {
        if (res.code === 200) {
          const data = res.payload;

          // Map API response data to the required payments structure
          const dynamicPayments = [
            {
              id: 1,
              amount: data.daily.today_amount,
              label: "Today's Revenue",
              expansion: data.daily.growth > 0 ? "growth" : "loss",
              growth: `${data.daily.growth}%`,
              unit: "yesterday",
              percentage: data.daily.progress,
              target_label: "Daily",
              target: `${data.daily.target} TK`,
            },
            {
              id: 2,
              amount: data.weekly.this_week_amount,
              label: "This Week",
              expansion: data.weekly.growth > 0 ? "growth" : "loss",
              growth: `${data.weekly.growth}%`,
              unit: "last week",
              percentage: data.weekly.progress,
              target_label: "Weekly",
              target: `${data.weekly.target} TK`,
            },
            {
              id: 3,
              amount: data.monthly.this_month_week,
              label: "This Month",
              expansion: data.monthly.growth > 0 ? "growth" : "loss",
              growth: `${data.monthly.growth}%`,
              unit: "last month",
              percentage: data.monthly.progress,
              target_label: "Monthly",
              target: `${data.monthly.target} TK`,
            },
          ];

          setTotalCash(Number.parseFloat(data.daily.total_cash).toFixed(2));
          setTotalCard(Number.parseFloat(data.daily.total_card).toFixed(2));
          setTotalOnline(Number.parseFloat(data.daily.total_online).toFixed(2));

          const totalMfs = roundNumber(data.daily.total_bkash + data.daily.total_nagad);

          setTotalMfsAmount(totalMfs.toFixed(2));

          setPayments(dynamicPayments);
        }
      });
    }
  };

  const onCloseViewLogModal = () => {
    setIsViewLogModalOpen(false);
  };

  const fetchOrderList = () => {
    // It will ensure that token and restaurant id will be present if exist in localStorage and remove the dependency from restaurantId and user state which may appear later from state
    const auth = getRestaurantIdWithAuthToken();
    const params = getOrderDefaultFilter();
    params.restaurantId = auth.restaurantId;
    params.perPage = 5;

    setLoadingOrder(true);
    ApiService.FILTER_ORDER_LIST(params, auth.token).then((res) => {
      if (!res || (res && res.code !== 200)) {
        setLoadingOrder(false);
        return;
      }

      let newOrders = res.payload.records.map((o) => getFormatedOrderList(o));

      setDashboardOrders(newOrders);
      setLoadingOrder(false);
      setHasFetched(true);
    });
  };

  const onFinishPaymentModal = async (result) => {
    if (result.success) {
      setIsPaymentModalOpen(false);
    }
  };

  const onClosePaymentModal = () => {
    setIsPaymentModalOpen(false);
  };

  const handleClosingOfDisplayInvoiceModal = () => {
    setIsDisplayInvoice(false);
  };

  useEffect(() => {
    if (shouldFetchDashboardOrders) {
      fetchOrderList();
      setShouldFetchDashboardOrders(false);
    }
  }, [shouldFetchDashboardOrders]);

  useEffect(() => {
    getDashboardSummary();
    fetchPaymentSummary(); // Fetch and set dynamic payments data on load
  }, []);

  useEffect(() => {
    // Stop the blinking animation after 3 seconds
    const timer = setTimeout(() => {
      setNewOrderId("");
    }, 3000);

    // Cleanup the timeout
    return () => clearTimeout(timer);
  }, [newOrderId]);

  const reloadPageData = () => {
    setSummaryData({});
    setTrendingItemsData([]);
    getDashboardSummary();
    fetchPaymentSummary();
  };
  return (
    <div className="flex flex-col overflow-none relative">
      {contextHolder}
      <CustomLoader />
      <div className="flex flex-col">
        <Header title={`McDonalds Food Chain`} menu={constants.MENU.DASHBOARD} currentMenuKey={"T_1_S_1"} />
        <div className="flex flex-row bg-prewhite">
          <SideMenu title={`McDonalds Food Chain`} menu={constants.MENU.DASHBOARD} />
          <div className=" p-[24px] w-full mt-[80px] ml-[72px]">
            <div className="flex flex-row w-full">
              <div className="block w-[75%]">
                <div className="flex flex-row mr-[8px] h-fit">
                  <div className="flex flex-col flex-grow justify-between h-[240px]">
                    <div className="flex flex-row">
                      <SummaryComponent
                        record={{
                          label: "Total Orders of Last 7 Days",
                          value: `${summaryData?.totalOrders ?? 0}`,
                        }}
                      />
                      <SummaryComponent
                        record={{
                          label: "Total Orders Today",
                          value: `${summaryData?.totalOrdersToday ?? 0}`,
                        }}
                      />
                    </div>
                    <div className="flex flex-row">
                      <SummaryComponent
                        record={{
                          label: "Customers This Month",
                          value: `${summaryData?.totalCustomersThisMonth ?? 0}`,
                          expansion: "growth",
                        }}
                      />
                      <SummaryComponent
                        record={{
                          label: "Returning Customers of This Month",
                          value: `${summaryData?.returningCustomers?.ratio ?? 0} %`,
                          expansion: `${(summaryData?.returningCustomers?.ratio ?? 0) > 100 ? "growth" : "loss"}`,
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="flex flex-col w-[300px] p-[24px] items-center mx-[8px] 
                  justify-between rounded bg-white"
                  >
                    <div className="font-ubold text-2xl mb-[8px]">Order Status</div>
                    <div className="font-uregular text-pregray text-md mb-[8px]">{`${
                      summaryData?.orderStatus?.pendingPercentage ?? 0
                    }% pending`}</div>
                    <Flex align="center" wrap gap={30}>
                      <Progress
                        type="circle"
                        percent={summaryData?.orderStatus?.completedPercentage ?? 0}
                        strokeColor={twoColors}
                        format={(percent) => {
                          let content = `${summaryData?.orderStatus?.completedPercentage ?? 0}%<br> completed`;
                          return (
                            <div
                              className="font-uregular text-pregray text-sm"
                              dangerouslySetInnerHTML={{ __html: content }}
                            />
                          );
                        }}
                      />
                    </Flex>
                  </div>
                </div>

                {/* start current order list */}
                <div id="currentOrders" className="flex flex-col flex-grow">
                  <div className="flex flex-row mt-[16px] mx-[12px] items-center">
                    <div className="font-ubold text-2xl text-preblack my-[16px] flex-grow">Current Orders</div>
                    <div
                      className="bg-purple text-white h-fit px-[16px] py-[8px] mr-[12px] rounded-[5px] font-ubold flex flex-row items-center cursor-pointer"
                      onClick={onClickSeeAllButton}
                    >
                      See All
                    </div>
                    <div
                      className="bg-yellow text-black h-fit px-[16px] py-[8px] rounded-[5px] font-ubold flex flex-row items-center cursor-pointer"
                      onClick={onClickAddButton}
                    >
                      Add Order
                    </div>
                  </div>
                  <div className="flex flex-col mx-[12px] py-3 items-center">
                    {loadingOrder && (
                      <div className="h-[30vh] flex items-center justify-center">
                        <Spin size="large" />
                      </div>
                    )}

                    {!loadingOrder &&
                      dashboardOrders.length > 0 &&
                      dashboardOrders.map((item, index) => (
                        <OrderComponent
                          key={`order-${index}`}
                          index={index}
                          record={item}
                          callback={onHandleOrderAction}
                          optimized
                          newOrderId={newOrderId}
                          sourcePage="Home"
                          shouldLockRow={shouldLockRow}
                          isTableManagement={tableManagement === "Active"}
                        />
                      ))}

                    {hasFetched && !loadingOrder && dashboardOrders.length === 0 && <DataNotFound />}
                  </div>
                </div>
                {/* end current order list */}

                {/* start trending items */}
                <div className="flex flex-row mt-[16px] mx-[12px] items-center">
                  <div className="font-ubold text-2xl text-preblack my-[16px] flex-grow">
                    Trending Items (Last 1 Month)
                  </div>
                </div>
                <div className="flex flex-row mt-[16px] mx-[12px] items-center">
                  <div className="font-ubold text-2xl text-preblack my-[16px] flex-grow">
                    <TrendingItemsChart data={trendingItemsData}></TrendingItemsChart>
                  </div>
                </div>
                {/* end trending items */}
              </div>

              <div className="w-[25%] font-uregular rounded bg-white p-[16px]">
                <div className="flex flex-row items-center justify-between">
                  <div className="text-2xl font-ubold text-green">Payments</div>
                  <div className="flex items-center cursor-pointer" onClick={reloadPageData}>
                    <Image src="/images/refresh-button.svg" width={24} height={24} preview={false} />
                  </div>
                </div>

                {/* start today's cash card */}
                <div className="w-full mt-[20px]">
                  <SummaryComponent
                    record={{
                      label: "Today's Cash",
                      value: `${totalCash ?? 0} TK`,
                    }}
                    background={"#572D86"}
                    textLabel={"#FFD700"}
                    text={"#E5E5E5"}
                  />
                </div>
                {/* end today's cash card */}

                {/* start today's pos card */}
                <div className="w-full mt-[20px]">
                  <SummaryComponent
                    record={{
                      label: "Today's POS",
                      value: `${totalCard ?? 0} TK`,
                    }}
                    background={"#572D86"}
                    textLabel={"#FFD700"}
                    text={"#E5E5E5"}
                  />
                </div>
                {/* end today's pos card */}

                {/* start today's pos card */}
                <div className="w-full mt-[20px]">
                  <SummaryComponent
                    record={{
                      label: "Today's MFS",
                      value: `${totalMfsAmount ?? 0} TK`,
                    }}
                    background={"#572D86"}
                    textLabel={"#FFD700"}
                    text={"#E5E5E5"}
                  />
                </div>
                {/* end today's pos card */}

                {/* start today's online card */}
                <div className="w-full mt-[20px]">
                  <SummaryComponent
                    record={{
                      label: "Today's Online",
                      value: `${totalOnline ?? 0} TK`,
                    }}
                    background={"#572D86"}
                    textLabel={"#FFD700"}
                    text={"#E5E5E5"}
                  />
                </div>
                {/* end today's online card */}
                <div className="mt-4">
                  <DashboardReportPrint />
                </div>

                {payments.map((item, index) => {
                  return <PaymentCardComponent record={item} index={index} key={index + 144} />;
                })}
              </div>
            </div>

            <ConfirmationModal
              openModal={isConfirmModalOpen}
              records={{
                onFinish: onConfirm,
                onCancel: onNotConfirm,
                titleMessage,
                showCookingTime,
                message: confirmationMessage,
                param: selectedItem,
                action: action,
              }}
            />
            <ViewOrderLogModal
              openModal={isViewLogModalOpen}
              records={{
                onCancel: onCloseViewLogModal,
                param: selectedItem,
              }}
            />

            <OrderPaymentModal
              totalAmount={amountToPay}
              cookingTime={cookingTime}
              openModal={isPaymentModalOpen}
              params={{
                onFinish: onFinishPaymentModal,
                onCancel: selectedItem.paid === 0 ? onNotConfirm : onClosePaymentModal,
                order: selectedItem,
              }}
            />

            <OrderPaymentRefundModal
              openModal={isPaymentRefundModalOpen}
              centered
              params={{
                onCancel: () => setIsPaymentRefundModalOpen(false),
                onHandleOk: () => setIsPaymentRefundModalOpen(false),
                order: selectedItem?.total ? { ...selectedItem } : { total: 0 },
              }}
            />

            <DisplayInvoice
              openModal={isDisplayInvoice}
              records={{
                onCancel: handleClosingOfDisplayInvoiceModal,
                param: selectedItem,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
